import { css } from '@emotion/css';
import { actImageUrl, commonGenresStyle} from 'Shared/frontend/eventPosters/MusicPoster';
import { genreList } from 'Shared/common/Macros';
import { Show } from 'solid-js';
import { eventNameStyle } from 'Shared/frontend/eventPosters/separated/Utils';
import { poster } from 'Shared/frontend/SettingsProvider';


const posterStyle = () => css({
	margin: '0 32px 0 32px',
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center'
});

const artistStyle = () => css({
	position: 'relative'
});

const pressShotStyle = () => css({
	display: 'block',
	maxWidth: '100%',
	height: 'auto'
});


export function TwoActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'twoActs');

	const hide = () => s()?.hide ?? [];
	const showName = () => P.name && ! s().hide?.includes('name');

	const eventSize = () => s().nameFontSize ?? theme().name.fontSize;
	const artistSize = () => s().artistNamesFontSize ?? theme().artistNames.fontSize;

	return (
		<div class={posterStyle()}>
			<div class={css(eventNameStyle(),{fontSize:eventSize()})}>
				<Show when={showName()} fallback={<>&nbsp;</>}>
					{P.name}
				</Show>
			</div>

			<Artist {...P.lineup[0]} hide={hide()} fontSize={artistSize()} />
			<Artist {...P.lineup[1]} hide={hide()} fontSize={artistSize()} />
		</div>
	);
}

function Artist(P)
{
	const artistDetailsOverlayStyle = () => css({
		position: 'absolute',
		bottom: 0,
		width: '100%',
		background: '#00000060',
		padding: 5
	});

	const artistNameStyle = () => css({
			width: '100%',
			color: '#fff', 
			fontSize: P.fontSize
	});

	const genresStyle = () => css(commonGenresStyle(), {
		fontSize: '0.7em',
		lineHeight: '1.5em'  //XXX MOSTLY JUST SPACING. THERE ARE BETTER WAYS....
	});

	const showName = () => !P.hide.includes('artistName') && P.name;
	const showGenres = () => !P.hide.includes('artistGenres') && P.mainGenre;

	return (
		<div class={artistStyle()}>
			<img class={pressShotStyle()} src={actImageUrl(P.image)} width={200} height={133}/>

			<Show when={showName() || showGenres()}>
				<div class={artistDetailsOverlayStyle()}>
					<Show when={showName()}>
						<div class={artistNameStyle()}>{P.name}</div>
					</Show>
					<Show when={showGenres()}>
						<div class={genresStyle()}>{ genreList(P) }</div>
					</Show>
				</div> 
			</Show>
		</div>
	);
}

